import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';
import { FeatureFlagsService } from 'src/app/services/infra/featureFlags/feature-flags.service';

export function reactMigrationGuard(flagKey: string): CanMatchFn {
  return () => {
    const featureFlagsService = inject(FeatureFlagsService);
    const isReactEnabled = featureFlagsService.isFeatureEnabled(flagKey);
    return !isReactEnabled;
  };
}
